var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.currentRouteName !== 'signin')?_c('Navigation',{attrs:{"navTitle":_vm.currentRouteName}}):_vm._e(),_c('v-main',[_c('v-container',{staticStyle:{"height":"100vh"},attrs:{"fluid":""}},[_c('alert'),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }